import React from 'react';
import { NavLink,  } from "react-router-dom";

class Footer extends React.Component{
    render(){
        return(
            // <!-- Footer Section -->
            <div className="foot-size">
            <div className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="f-left">
                                <ul>
                                    <li><span id="siteseal"><a href="https://seal.godaddy.com/verifySeal?sealID=l6cSozASgSSuBtTdkIaVsEKvgwcLrppt6j7G73r2cty5V88utnuVltAl6qz0"
rel="noopener noreferrer" target="_blank"> <img style={{cursor:'hand'}} src="https://seal.godaddy.com/images/3/en/siteseal_gd_3_h_l_m.gif" width="100px" alt="SSL site seal - click to verify"/> </a></span></li>
                                    <li><a href="https://ferndaleroad.com/" rel="noopener noreferrer" target="_blank">Powered by FerndaleRoad</a></li>
                                    <li> &nbsp;&nbsp;Version 1.0</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
    
                            <div className="f-right">
                                <ul>
                                <li> <a href="https://ferndaleroad.com/about-us/" rel="noopener noreferrer" target="_blank"> About Us</a></li>
                                    <li><NavLink to="/Contact"  > Contact and Support</NavLink></li>
                                    <li><NavLink to="/FaqPage"  >FAQ</NavLink></li>

                                    <li><NavLink to="/PrivacyPage">Privacy Policy</NavLink></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div></div>
 
        )
    }
}
export default Footer;